import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    company: { assignations: url, automaticAssigment },
  },
} = config

const getUrl = (assignation) => url.replace(':idCompany', assignation.dashuser.company)

const get = (assignation = {}) =>
  axios.get(getUrl(assignation), {
    headers: getHeaders(true),
    params: { brands: assignation.brands || '', delegationIds: assignation.delegations || '' },
  })

/**
 * Activate automaticAssigment
 * @param {boolean} isEnabled
 */
const postAutomaticAssigment = (isEnabled) => {
  return axios({
    method: 'post',
    url: automaticAssigment,
    headers: getHeaders(true),
    data: { isEnabled }
  })
}


export default { get, postAutomaticAssigment }
